// extracted by mini-css-extract-plugin
export var active = "Button-module--active--a49bd";
export var container = "Button-module--container--7c779";
export var ghost = "Button-module--ghost--162a4";
export var group = "Button-module--group--b554d";
export var hideLabel = "Button-module--hide-label--b9ac5";
export var icon = "Button-module--icon--0f6b3";
export var label = "Button-module--label--e51e5";
export var primary = "Button-module--primary--8a74d";
export var secondary = "Button-module--secondary--2b7fa";
export var small = "Button-module--small--17c27";
export var text = "Button-module--text--c2b31";